import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { submitLoanOffer } from '../../apis/loan';
import { handleApiError } from '../../helpers';
import { LoanOffer, LoanOfferDto } from '../../interfaces';
import { addLoanOffer } from '../../states/action_creators/loan.action_creator';
import { RootState } from '../../states/reducers';
import useToggle from '../useToggle';

export const useSubmitLoanOffer = () => {
  const { id } = useParams<{ id: string }>();

  const [submittingOffer, setSubmitting] = useState(false);
  const { show: showForm, toggle: toggleForm } = useToggle();

  const { auth } = useSelector((state: RootState) => state);
  const user = auth.authUser!.user;

  const dispatch = useDispatch();

  const onSubmitOfferHandler = async (payload: LoanOfferDto) => {
    setSubmitting(true);
    try {
      payload.loan_id = +id;
      payload.tenure = +payload.tenure;
      payload.interest = +payload.interest;

      const response = await submitLoanOffer(payload);
      const offer: LoanOffer = response.data;
      offer.user = user;
      dispatch(addLoanOffer(offer));

      setSubmitting(false);
      toggleForm();
      toast.success('Your offer has been received by the borrower');
    } catch (error) {
      toast.error(handleApiError(error));
      setSubmitting(false);
    }
  };

  return {
    onSubmitOfferHandler,
    submittingOffer,
    showForm,
    toggleForm,
  };
};
